const en = {
    message: {
        login: "Account Login",
        submit: "Submit",
        accountInfo: "Account Information",
        accountNumber: "Account Number",
        serviceLocationAddress: "Service Location Address",
        billOptions: "Bill Options",
        autopay: "AutoPay",
        upcomingPaymentArrangement: "Upcoming Payment Arrangement",
        usageSummary: "Usage Summary",
        billHistory: "View Bill History",
        currentBill: "View Current Bill",
        payNow: "Pay Now",
        asOf: "As of",
        recentUsage: "Recent Usage",
        usageChartsFooterMessage: "Click on items above to remove from chart display",
        servicePoints: "Premise | Premises",
        type: "Type",
        status: "Status",
        avgDailyUsage: "Avg. Daily Usage",
        view: "View",
        dollarsRemaining: "Dollars Remaining",
        deferredBalance: "Deferred Balance",
        daysRemaining: "Days Remaining",
        billingCycle: "Billing Cycle",
        lastPayment: "Last Payment",
        totalCharges: "Total Charges",
        billDate: "Bill Date",
        billingPeriod: "Billing Period",
        daysInBillingPeriod: "Days in Billing Period",
        totalAmountBilled: "Total Amount Billed",
        pastDue: "Past Due",
        totalDue: "Total Due",
        registrationNumber: "Registration Number",
        total: "Total",
        convertToPDF: "Convert to PDF",
        print: "Print",
        close: "Close",
        dollars: "Dollars",
        consumption: "Consumption",
        backToMonthly: "Back To Monthly",
        backToDaily: "Back To Daily",
        lastName: "Last Name",
        next: "Next",
        zipcode: "Zip Code",
        registerNewAccount: "Register New Account",
        startManagingYourAccount: "Get started managing your account now!",
        currentNotificationSettings: "Current Notification Settings:",
        voice: "Voice: ",
        text: "Text Message: ",
        email: "Email: ",
        emailaddress: "Email Address: ",
        phonenumberoremailaddress: "Phone Number or Email Address",
        notificationSettingsPage: "Notification Settings page",
        approxDollarsRemaining: "Approx Dollars Remaining",
        deferredBalance: "Deferred Balance",
        approxDaysRemaining: "Approx Days Remaining: ",
        accountBalance: "Account Balance: ",
        avgDailyConsumption: "Avg Daily Consumption: ",
        avgDailyDollarConsumption: "Avg Daily Dollar Consumption: ",
        accountBalanceCustomerMessage: "Below you will find the account balances. You may transfer or adjust funds between the accounts. If you need a refund, or to move funds from one account to another, please call customer support.",
        ok: "Ok",
        cancel: "Cancel",
        transferDeferredMessage: "Please enter an amount between $0 and ${maxFunds} to apply to your deferred balance. If the amount you requested to transfer exceeds the actual account balance, then we will only transfer what is available.",
        transferAmount: "Transfer Amount: ",
        account: "Account",
        transferAmountTooMuch: "The transfer amount is greater than the max available funds.",
        transfer: "Transfer",
        currentPassword: "Current Password",
        newPassword: "New Password",
        confirmNewPassword: "Confirm New Password",
        confirmPassword: "Confirm Password",
        currentUsername: "Current Username",
        newUsername: "New Username",
        confirmNewUsername: "Confirm New Username",
        emailAsUsername: "An email address is required as your username.",
        highTemperature: "High Temperature",
        lowTemperature: "Low Temperature",
        temperature: "Temperature",
        privacyPolicy: "Privacy Policy",
        copyright: "Copyright",
        serviceLocation: "Service Location",
        username: "Username",
        password: "Password",
        rememberUsername: "Remember Username",
        supportInfo: "Support Info",
        home: "Home",
        reports: "Reports",
        usage: "Usage",
        notification: "Notification",
        payment: "Payment",
        autopay: "Autopay",
        support: "Support",
        csrportal: "CSR Portal",
        welcome: "Welcome",
        balance: "Balance",
        profile: "Profile",
        logout: "Log Out",
        report: "Report",
        selectAReport: "Select A Report",
        getCSV: "Get CSV",
        printerFriendly: "Printer Friendly",
        runReport: "Run Report",
        notificationContact: "Notification Contact",
        chargesNote: "Data and messaging carrier charges may apply",
        active: "Active",
        addNew: "Add New",
        noContactsAvailable: "No Contacts Available",
        verify: "Verify",
        delete: "Delete",
        notificationWindow: "Notification Window",
        change: "Change",
        lowBalanceNotifications: "Low Balance Notifications",
        lowBalanceNotificationDaysSelected: "Low Balance Notification Days Selected",
        noDataAvailable: "No data available",
        billingAddress: "Billing Address",
        changeAddress: "Change Address",
        addContact: "Add Contact",
        save: "Save",
        and: "and",
        anytime: "Any time of day or night",
        onlybetween: "Only between",
        changeNotificationWindow: "Change Notification Window",
        deleteContact: "Delete Contact",
        deleteContactConfirmation: "Are you sure you wish to delete",
        verifyCode: "Verify Code",
        optInToTexting: "Opt-In To Texting",
        verificationCode: "Verification Code",
        optInCodeText: "We have sent a text message with an OptInCode. Please type the code below to confirm that you agree to receiving text messages from PayGo.",
        optin: "Opted In",
        optinpending: "Opt In Pending",
        optoutpending: "Opt Out Pending",
        enteryouraddressin: "Enter your address in",
        enteracity: "Enter a City",
        selectastate: "Select a State",
        enterazipcode: "Enter a Zip Code",
        entervalidemailaddress: "Error! Please enter a valid email address",
        entervalidphone: "Error! Please enter a valid phone number",
        entervalidphoneoremail: "Error!  Please enter either a valid phone number or a valid email address.",
        errorPageFailed: "An error has occurred.  Please refresh your page.",
        address1: "Address 1",
        address2: "Address 2",
        city: "City",
        state: "State",
        zip: "Zip",
        criticalContact: "Critical Contact",
        limit: "Limit: ",
        add: "Add",
        supportInfo: "Support Info",
        capsLockOn: "CAPS LOCKS ON",
        errorMessage: "We apologize, but an error occurred and your request could not be completed. Our team was notified and we are working on resolving this error.",
        backToHome: "Go back to Home page",
        sessionWarning: "Session Warning",
        backToLogin: "Back to Login",
        passwordMustContain: "Password must contain at least",
        addingAccountToExistingLogin: "If you are adding an account to an existing login, enter the username and password for that login below.",
        terms: "I agree to the terms and conditions of this contract.",
        phoneOrEmail: "Phone / Email",
        startDate: "Start Date",
        endDate: "End Date",
        daterange: "Date Range",
        phone: "Phone: ",
        //I have a need to get the specific format for date pickers.  I also need the current language setting
        dateformat: "MM/DD/YYYY",
        //Report Headers
        accountlast4: 'Account Last 4',
        action: 'Action',
        amount: 'Amount',
        applystatus: 'Apply Status',
        changeamount: 'Change Amount',
        changedate: 'Change Date',
        contactinfo: 'Contact Info',
        date: 'Date',
        delivered: 'Delivered',
        description: 'Description',
        details: 'Details',
        endingbalance: 'Ending Balance',
        generateddate: 'Generated Date',
        message: 'Message',
        messagetype: 'Message Type',
        meternumber: 'Meter Number',
        meterreading: 'Meter Reading',
        meterstatus: 'Meter Status',
        paymenttype: 'Payment Type',
        premisename: 'Premise Name',
        readdate: 'Read Date',
        recieved: 'Recieved',
        senddate: 'Send Date',
        sendstatus: 'Send Status',
        serialno: 'Serial No',
        subject: 'Subject',
        totalconsumption: 'Total Consumption',
        type: 'Type',
        unit: 'Unit',
        voided: 'Voided',
        //Reports
        accountactivity: 'Account Activity',
        accountbalanceactivity: 'Account Balance Activity',
        deferredbalanceactivity: 'Deferred Balance Activity',
        meterreadhistory: 'Meter Read History',
        meterStatushistory: 'Meter Status History',
        notificationhistory: 'Notification History',
        processedpayments: 'Processed Payments',
        usagestatement: 'Usage Statement',
        estUsage: "EST. USAGE",
        weatherTitle: "{days} DAY FORECAST / EST. USAGE",
        noForecastDataAvailable: "No forecast data is available",
        //Thermostats
        getNestThermostat: "You do not currently have a Nest thermostat registered.  Click below to give Georgia Power permission to retrieve your data for you.",
        loginToNest: "Login to Nest",
        thermostats: "Thermostats",
        thermostat: "Thermostat",
        thermOff: "Off",
        heating: "Heating",
        cooling: "Cooling",
        target: "Target",
        off: "Off",
        enterDailyGoal: "Enter your Daily Goal",
        setDailyGoal: "Set Daily Goal",
        removeDailyGoal: "Remove Daily Goal",
        lastMonth: "Last Month",
        last3Months: "Last 3 Months",
        last6Months: "Last 6 Months",
        last9Months: "Last 9 Months",
        customRange: "Custom Range",
        selectPaymentOption: "Please select a payment option",
        noPaymentTypesAvailable: "No Payment Processors are available.",
        notificationType: "Notification Type",
        accountNotValid: "Account Not Valid",
        defaultSavedPayment: "Default Saved Payment Method",
        managePaymentMethods: "Manage Payment Methods",
        noPaymentMethodAvailableMessage: "You do not have a saved default payment method. Please add one below.",
        autoPayMessage: "Your account(s) can be setup to refill your balance when an estimated two days are remaining. The chosen amount will be deducted from your default credit or debit card at that time.",
        routingNumber: "Routing #",
        expired: "Expired",
        autoPayWarning: "You do not have a default payment method available. Any selected Auto Pay payments will not be processed without a default payment method. Please add one below.",
        noActivePremisesAvailable: "No active premises are available.",
        coverDeferredBalance: "Cover Deferred Balance",
        unenroll: "Unenroll",
        autopaySavedMessage: "Autopay amount has been saved. Would you like to initiate an auto payment of ${autopayAmt}?",
        applyPaymentNow: "Apply Payment Now?",
        noRecordsToDisplay: "No records to display.",
        premise: "Premise",
        selectLocation: "Select a Location",
        statementDate: "Statement Date",
        address: "Address",
        currentCharges: "Current Charges",
        usageCharge: "Usage Charge",
        miscAdjustments: "Misc. Adjustments",
        totalCurrentCharges: "Total Current Charges",
        meterNum: "Meter #",
        servicePeriod: "Service Period",
        daysOfService: "Days of Service",
        startReading: "Start Reading",
        endReading: "End Reading",
        uomUsed: "{uom} used",
        consumptionCharges: "Consumption Charges",
        rateName: "Rate Name",
        rateDescription: "Rate Description",
        amountCharged: "Amount Charged",
        subtotal: "Subtotal",
        itemName: "Item Name",
        itemAmount: "Item Amount",
        viewStatement: "View Statement",
        statementDates: "Statement Dates",
        serviceType: "Service Type",
        charges: "Charges",
        adjustments: "Adjustments",
        adjustment: "Adjustment",
        unitsUsed: "Units Used",
        reconnectHeading: "Reconnect the Meter",
        reconnectMessage: "This will allow you to restore power to your meter. Please ensure that all electrical appliances are off, and will not pose a danger when power is restored. You assume all responsibility for restoring power to the meter.",
        connect: "Connect",
        notAuthorizedMessage: "You are not authorized to access this page.",
        sessionTimeoutMessage: "Session Timeout: Your session has ended for your security. Please start again.",
        welcomeMessage: "Welcome To {repName}!!",
        welcomePageNotificationMessage: "To add to or edit contact methods go to ",
        unsubscribe: "Unsubscribe",
        unsubscribeSuccessText: "Thank you! Your email {email} has been successfully unsubscribed. ",
        unsubscribeFailText: "We were not able to unsubscribe your email {email} due to program rules requiring at least one email or text message option to be enabled. ",
        unsubscribeLoginText: "Please click here to update your notifications.",
        sendBarcode: "Send Barcode",
        dailyUsageAlert: "Daily Usage Alert"
    }
}

export default en
